import React from "react";
import TurnrInput from "~/components/input/TurnrInput.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";

export default function BackgroundImageSettings(props) {
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    fullWidth={true}
                    {...props.backgroundImage}
                    onChange={props.setBackgroundImage}
                    tooltip="Paste the url to an image, gif or video and you will see how the background changes in the preview. Can be a img, gif or video."
                    label="Background img"
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    fullWidth={true}
                    {...props.backgroundImageMobile}
                    onChange={props.setBackgroundImageMobile}
                    tooltip="Set this if you want another image specifically for the mobile view. For example you might want a different ratio image for resolution reasons"
                    label="Background img mobile"
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="If you want some background media specifically for the login page. Can be a img, gif or video."
                    label="Background login page img"
                    fullWidth={true}
                    {...props.startBackground}
                    onChange={props.setStartBackground}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="If you want some background media specifically for the success page. Navigate the preview to the success page to see it. Can be a img, gif or video."
                    label="Background success page img"
                    fullWidth={true}
                    {...props.successBackground}
                    onChange={props.setSuccessBackground}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
